import { render, staticRenderFns } from "./CobranzaShowData.vue?vue&type=template&id=0804acef"
import script from "./CobranzaShowData.vue?vue&type=script&lang=js"
export * from "./CobranzaShowData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports